import { useEffect, useRef } from "react"
import { Sizes } from "@bappweb/provider"
import * as Constants from "./constants"

export function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef()
  // Store current value in ref
  useEffect(() => {
    ref.current = value
  }, [value]) // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)
  return ref.current
}

/**
 * metinden gün, ay ve yıl bilgisini parse edip bir obje olarak döndürür
 * @param {string} str ddMMyyyy veya dd.MM.yyyy şeklinde string değer
 */
export function getDayMonthYearFromStr(str) {
  let day = ""
  let month = ""
  let year = ""

  if (str.length === 8) {
    day = str.substr(0, 2)
    month = str.substr(2, 2)
    year = str.substr(4, 4)
  } else if (str.length === 10) {
    day = str.substr(0, 2)
    month = str.substr(3, 2)
    year = str.substr(6, 4)
  } else {
    // eslint-disable-next-line
    throw "str does not have a valid date format. valid format is ddMMyyyy or dd/MM/yyyy"
  }
  return {
    day,
    month,
    year
  }
}

export function createUUID() {
  let uuid = self.crypto.randomUUID() // eslint-disable-line

  // var dt = new Date().getTime();
  // var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
  //     var r = (dt + Math.random() * 16) % 16 | 0; // eslint-disable-line
  //     dt = Math.floor(dt / 16);
  //     return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16); // eslint-disable-line
  // });

  return uuid
}

  
  export function isNullOrEmpty(val){
    if (typeof val === 'undefined' || val === null || val === ''){
      return true
    }
    return false
  }

  export function isMobileDevice() {
    /*eslint-disable */
    let check = false;
    (function(a){if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent || navigator.vendor || (window as any).opera);// eslint-disable-line
    return check;
    /*eslint-enable */
  }

  export function getDeviceTypeFromSize(size){
    size = (size === undefined) ? Sizes.xs : size
  
    switch (size) {
      case Sizes.xs:
        return Constants.DeviceTypes.MOBILE;
      case Sizes.md:
        return Constants.DeviceTypes.TABLET;
      default:
        return Constants.DeviceTypes.DESKTOP
    }
  }

  export function addThousandSeparator(originalAmt, addDecimal = true) {
    let strOrgAmt = originalAmt.toString()
    let intPart,
      decimalPart = ""
  
    //Orjinalinde ondalık ayıracı olarak virgül (,) kullanılıyordu
    //let containsDecimal = strOrgAmt.search(/,\d+/gi) >= 0
    let containsDecimal = strOrgAmt.search(/\.\d+/gi) >= 0
    if (containsDecimal) {
      //const parts = strOrgAmt.split(",")
      const parts = strOrgAmt.split(".")
      intPart = parts[0]
      decimalPart = parts[1].length < 2 ? parts[1] + "0" : parts[1]
    } else {
      intPart = strOrgAmt
      decimalPart = "00"
    }
    let result = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    if (addDecimal) {
      return result + "," + decimalPart
    }
  
    return result
  }

  /**
  * Javascript native Date objesini dd.MM.yyyy formatında stringe döndürür
  * @param {Date} date Javascript native date objesi
  * @returns {string} dd.MM.yyyy formatında tarih string
  */
  export function dateToString(date){
    const year = date.getFullYear()
    let monthStr = (date.getMonth() + 1).toString()
    if (monthStr.length < 2){
        monthStr = "0" + monthStr
    }
    let dayStr = date.getDate().toString()
    if (dayStr.length < 2){
        dayStr = "0" + dayStr
    }
  
    return dayStr + "." + monthStr + "." + year
  }

  export function getCidParameter(){
    let search = window.location.search;
    let params = new URLSearchParams(search);
    return params.get('cid');
  }
  
export function readCookie(cookieName) {
  let session = "";
  let cookie = document.cookie; // eslint-disable-line
  if (cookie !== "" && typeof (cookie) !== typeof (undefined)) {
    var splittedCookie = cookie.split(";");

    if (splittedCookie?.length > 0 && typeof (splittedCookie) !== typeof (undefined) && splittedCookie.length > 0) {
      for (var i = 0; i < splittedCookie.length; i++) {
        var cookieValues = splittedCookie[i]?.split("=");

        if (cookieValues !== undefined && cookieValues?.length > 0 && typeof (cookieValues) !== typeof (undefined)) {
          if (cookieValues[0]?.replace(" ", "") === cookieName) {
            session = cookieValues[1] ?? "";
            break;
          }
        }
      }
    }
  }
  return session;
}

export function isValidYear(year: string): boolean {
  // 4 basamaklı mı ve sadece rakamlardan mı oluşuyor?
  if (!/^\d{4}$/.test(year)) return false;  
  const numYear = Number(year);
  // Mantıklı bir aralıkta mı? (ör: 1900-2200)
  return numYear >= 1900 && numYear <= 2200;
}

export type SMPUConfigListResponse = {
  configKey: string,
  configValue: string
}

export const getConfigValue = (configList: SMPUConfigListResponse[] | undefined, configKey: string) => {
  return configList?.find((item) => item.configKey === configKey)?.configValue ?? "";
}


export const getQueryStringValue = (paramName, defaultValue) => {
  const queryParams = new URLSearchParams(window.location.search)
  if (queryParams) {
    let retVal: any = queryParams.get(paramName)
    if (retVal) {
      return retVal
    }
    return defaultValue
  }
}

export const cleanTextContent = (strText: string) => {
  if (strText === null || strText.trim() === "") {
    return strText;
  }

  const strOut = strText.replace(/</g, "&lt;").replace(/>/g, "&gt;");

  return strOut;
}

export const cleanXss = (strText: string | null) => {
  if (strText === null || strText.trim() === "") {
    return strText;
  }

  let strOut = cleanTextContent(strText);

  strOut = strOut.replace(/<(.|\n)*?>/g, "");

  strOut = strOut.replace(/(['"])/g, "");

  return strOut;
}
